import React from 'react'
import pt from 'prop-types'
import noop from 'lodash/noop'
import SearchAndFilter from '../SearchAndFilter'

import {
  Container,
} from './styles'

const NewIntegration = ({
  cityProcesses,
  integrations,
  click,
  intl
}) => (
  <Container>
    <SearchAndFilter
      cityProcesses={cityProcesses}
      integrations={integrations}
      intl={intl}
      click={click}
    />
  </Container>
)

NewIntegration.defaultProps = {
  integrationTypes: [],
  integrationOptions: [],
  click: noop,
}
NewIntegration.propTypes = {
  integrationTypes: pt.arrayOf(pt.shape({
    id: pt.number,
    tag: pt.string,
    name: pt.string,
    type: pt.string,
  })),
  integrationOptions: pt.arrayOf(pt.shape({
    id: pt.number,
    tags: pt.arrayOf(pt.string),
    name: pt.string,
    type: pt.string,
  })),
  click: pt.func,
}

export default NewIntegration
